document.addEventListener('DOMContentLoaded', () => {

    const soundToggle = document.querySelector('.video-sound');
    const navigation = document.querySelector('.navigation');
    const navigationItems = document.querySelectorAll('.navigation__item');
    const navToggle = document.querySelector('.navigation__head');
    const navigationHeight = navigation.scrollHeight;
    const navSubToggles = document.querySelectorAll('.js-toggleSub');

    const headerSlides = document.querySelectorAll('.mainHeader__backgroundSlide');
    const slidePrevToggle = document.querySelector('.js-sliderPrev');
    const slideNextToggle = document.querySelector('.js-sliderNext');

    let navState = false;
    let slideIndex = 0;
    let currentNavHeight = 0;

    const toggleNavigation = () => {
        if(navState) {
            (navigation as any).style.maxHeight = `0px`;
            currentNavHeight = 0;
            navSubToggles.forEach((elem) => {
                const subMenu = elem.parentElement.parentElement?.querySelector('ul');
                subMenu.style.maxHeight = '0px';
                subMenu.removeAttribute('data-active');
            })
        } else {
            (navigation as any).style.maxHeight = `${navigationHeight}px`;
            currentNavHeight = navigationHeight;
        }
        navState = !navState;
    }

    navSubToggles.forEach((elem) => {
        elem.addEventListener('click', () => {
            const subMenu = elem.parentElement.parentElement?.querySelector('ul');
            const currentState = subMenu.hasAttribute('data-active');
            if(currentState) {
                subMenu.style.maxHeight = '0px';
                currentNavHeight -= subMenu.scrollHeight
                subMenu.removeAttribute('data-active');
            } else {
                subMenu.style.maxHeight = `${subMenu.scrollHeight}px`;
                currentNavHeight += subMenu.scrollHeight;
                subMenu.setAttribute('data-active', '');
            }
            (navigation as any).style.maxHeight = `${currentNavHeight}px`;
        })
    })

    navToggle.addEventListener('click', toggleNavigation);

    const slide = (index: number) => {
        headerSlides.forEach((elem) => elem.classList.remove('active'))
        headerSlides[index].classList.add('active');

        if(headerSlides[index].classList.contains('is-video')) {
            soundToggle.classList.remove('hide')
        } else {
            soundToggle.classList.add('hide');
        }

        slideIndex = index;
    }

    slidePrevToggle.addEventListener('click', () => {
        if(slideIndex === 0) {
            slide(headerSlides.length - 1);
        } else {
            slide(slideIndex - 1)
        }
    })

    slideNextToggle.addEventListener('click', () => {
        if(slideIndex === headerSlides.length - 1) {
            slide(0);
        } else {
            slide(slideIndex + 1);
        }
    });

    if(soundToggle) {
        soundToggle.addEventListener('click', () => {
            const video = document.querySelector('video');
            video.muted = !video.muted;
            soundToggle.setAttribute('data-sound', !video.muted ? 'true' : 'false')
        })
    }

})